var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00374 7.00127C1.9091 7.00159 1.81632 6.97506 1.73617 6.92475C1.65602 6.87444 1.59179 6.80242 1.55094 6.71705C1.51009 6.63169 1.4943 6.53649 1.50541 6.44251C1.51651 6.34853 1.55406 6.25963 1.61368 6.18614L6.56445 1.08534C6.60159 1.04247 6.6522 1.01351 6.70797 1.00319C6.76374 0.992879 6.82136 1.00183 6.87137 1.02858C6.92138 1.05533 6.96081 1.09829 6.98319 1.1504C7.00557 1.20252 7.00956 1.26069 6.99452 1.31538L6.03437 4.32585C6.00606 4.40162 5.99655 4.48313 6.00666 4.56339C6.01677 4.64365 6.0462 4.72025 6.09243 4.78663C6.13865 4.85302 6.20028 4.9072 6.27205 4.94453C6.34381 4.98185 6.42356 5.00122 6.50445 5.00095H10.005C10.0996 5.00063 10.1924 5.02717 10.2726 5.07748C10.3527 5.12779 10.4169 5.19981 10.4578 5.28517C10.4986 5.37053 10.5144 5.46573 10.5033 5.55971C10.4922 5.65369 10.4547 5.74259 10.3951 5.81608L5.44428 10.9169C5.40714 10.9598 5.35654 10.9887 5.30077 10.999C5.245 11.0093 5.18738 11.0004 5.13737 10.9736C5.08735 10.9469 5.04792 10.9039 5.02554 10.8518C5.00317 10.7997 4.99917 10.7415 5.01421 10.6868L5.97436 7.67638C6.00267 7.6006 6.01218 7.51909 6.00207 7.43883C5.99196 7.35858 5.96253 7.28197 5.91631 7.21559C5.87009 7.14921 5.80845 7.09503 5.73669 7.0577C5.66492 7.02037 5.58518 7.00101 5.50429 7.00127H2.00374Z",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon);
export default __webpack_public_path__ + "static/media/step-icon.bfff3f8d5a5088e0aff2a6c8eead5ac1.svg";
export { ForwardRef as ReactComponent };